import type React from 'react';

type IProps = {
  show: boolean;
  // * Only passed for bots with streaming enabled - shares the streaming
  // * bubble's configurable color so the two dot animations never show
  // * mismatched colors back-to-back. Omitted for non-streaming bots, which
  // * keep the default dark-grey dot.
  indicatorColor?: string;
};

const TypingIndicator: React.FC<IProps> = ({ show, indicatorColor }) => {
  const dotStyle = indicatorColor
    ? { backgroundColor: indicatorColor }
    : undefined;

  return (
    <>
      {show && (
        <div className='typing-indicator-container'>
          <div className='typing-indicator-row'>
            <div className='typing-indicator-dot' style={dotStyle} />
            <div className='typing-indicator-dot' style={dotStyle} />
            <div className='typing-indicator-dot' style={dotStyle} />
          </div>
        </div>
      )}
    </>
  );
};

export default TypingIndicator;
